import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'

// A long form, given a screen of its own.
//
// Sheet is for a question with an answer -- a picker, a confirmation, a couple
// of fields. CreateProduct is not that: it runs to 1241px of scroll, 574px of it
// below the fold on a phone, across a dozen fields, a photo, and a generated
// title that changes as you type. It was living in the same popup as the
// two-button confirmations, which had no max-height below 600px, so Save sat
// past the bottom edge of the screen with nothing to scroll.
//
// The shape here is Page's, with one addition: the actions are pinned to the
// bottom rather than trailing the content. In a form this long that is the
// difference between Save being a control and Save being a destination.
const NAV_HEIGHT = 65

export default function FormPage(props) {
    const { title, subtitle, onSubmit, actions, measure, children } = props

    // One measure for all three bands. Constraining only the fields left the
    // heading hard against the left edge of a wide monitor and Save spanning the
    // whole window, both of them detached from the form they belong to.
    const band = { maxWidth: measure || 'none', marginLeft: 'auto', marginRight: 'auto' }

    return (
        <Box
            component='form'
            onSubmit={onSubmit}
            sx={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}
            // Inline, like Page's, so a test can prove it is an expression rather
            // than a pixel value measured once and left to go stale.
            style={{ height: `calc(100dvh - ${NAV_HEIGHT}px)` }}
        >
            <Box sx={{ flex: 'none', px: 2, py: 1 }}>
                <Box data-testid='form-measure' sx={band}>
                    <Typography variant='h6'>{title}</Typography>
                    {/* The live generated title, on the products form. It belongs with
                        the heading rather than buried in the fields it is derived from. */}
                    {subtitle && (
                        <Typography variant='body2' color='text.secondary' noWrap>
                            {subtitle}
                        </Typography>
                    )}
                </Box>
            </Box>

            <Divider />

            <Container
                data-testid='form-body'
                sx={{
                    flex: 1,
                    minHeight: 0,
                    width: '100%',
                    overflowY: 'auto',
                    py: 2
                }}
            >
                <Box data-testid='form-measure' sx={band}>{children}</Box>
            </Container>

            {actions && (
                <>
                    <Divider />
                    <Box
                        data-testid='form-actions'
                        sx={{
                            flex: 'none',
                            px: 2,
                            pt: 1.5,
                            // Home-screen installs and notched phones: without this
                            // the primary action sits under the gesture bar.
                            pb: 'calc(12px + env(safe-area-inset-bottom))'
                        }}
                    >
                        <Box data-testid='form-measure' sx={band}>{actions}</Box>
                    </Box>
                </>
            )}
        </Box>
    )
}
